<template>
    <div v-if="$store.state.settings.activeTab === 'Settings_Publisher'">
        <v-row class="d-flex justify-center">
            <v-col cols="12" lg="10" xl="9">
                <Datatable :headers="tableHeaders" :items="publisher" title="Publisher" :items-per-page="-1"
                           @click:row="emitClicked"
                           @click:edit="emitClicked"
                           @click:delete="emitClicked($event, true)"
                >
                    <template #top>
                        <Button v-if="$vuetify.breakpoint.mdAndUp" icon="mdi-plus"
                                :color="ada.blue" @click="emitClicked(null)">Publisher hinzufügen
                        </Button>
                    </template>
                </Datatable>
            </v-col>
        </v-row>
        <AddEditPublisherDialog v-model="showDialog"></AddEditPublisherDialog>
        <DeletePublisherDialog v-model="showDeleteDialog"></DeletePublisherDialog>
    </div>
</template>

<script>
import Datatable from "../../../components/Tables/Datatable";
import ada from "../../../scss/ada_colors.scss";
import Button from "../../../components/buttons/Button";
import AddEditPublisherDialog from "../Dialogs/AddEditPublisherDialog";
import DeletePublisherDialog from "../Dialogs/DeletePublisherDialog";

export default {
    name: "Settings_Publisher",
    components: {DeletePublisherDialog, AddEditPublisherDialog, Button, Datatable},
    data: () => {
        return {
            tableHeaders: [
                {text: 'Bezeichnung', value: 'Name'},
                {text: 'Aktion', value: 'action', width: '100px', sortable: false},
            ],
            showDialog: false,
            showDeleteDialog: false,
            ada
        }
    },
    mounted() {
        this.$store.dispatch('settings/fetchGeneralTargetingList');
    },
    computed: {
        vuexState() {
            return this.$store.state.settings;
        },
        publisher() {
            let publisher = this.vuexState.publisher ? this.vuexState.publisher : [];
            publisher.forEach((item) => {
                item.action = ['edit', 'delete'];
            })
            return publisher;
        }
    },
    methods: {
        emitClicked(item, deleting = false) {
            this.$emit('click', item, deleting, this);
        },
    },
}
</script>

<style scoped>

</style>